const ContentActionTypes = {
  GENERATE_CONTENT: "GENERATE_CONTENT",
  GET_TOPICS: "GET_TOPICS",
  CHANGE_STATUS: "CHANGE_STATUS",
  UPDATE_LANGUAGE: "UPDATE_LANGUAGE",
  SAVE_FORM: "SAVE_FORM",
};

export default ContentActionTypes;
